<ng-container *transloco="let t"
  ><h3>
    {{
      t('driver-analysis-dialog.driver-questions-step.select-questions', {
        minQuestions: limits.minQuestions,
        maxQuestions: limits.maxQuestions,
      })
    }}
  </h3>

  @if (isLoading) {
    <div class="xi-loader-container__center">
      <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
    </div>
  }

  <div class="driver-question-step__scroll-container">
    @if (!isLoading && !dataSource.data.length) {
      <p>
        {{ t('driver-analysis-dialog.driver-questions-step.no-questions-available') }}
      </p>
    }

    <table mat-table [dataSource]="dataSource" class="driver-questions-step__table">
      <ng-container matColumnDef="question">
        <th mat-header-cell *matHeaderCellDef>
          <xi-checkbox
            [checked]="isAllQuestionsChecked()"
            label="{{ t('driver-analysis-dialog.driver-questions-step.question') }}"
            color="orca"
            (onChange)="onAllQuestionsToggled($event.detail.target.checked)"
          ></xi-checkbox>
        </th>
        <td mat-cell *matCellDef="let element">
          <xi-checkbox
            [checked]="isQuestionChecked(element.value)"
            [label]="element.label"
            color="orca"
            (onChange)="onQuestionToggled($event.detail.target.checked, element.value)"
          ></xi-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="conversion">
        <th mat-header-cell *matHeaderCellDef>
          {{ t('driver-analysis-dialog.driver-questions-step.conversion') }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.value | conversionPipe: fieldStatistics | number: '1.0-0' }}%
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</ng-container>
